var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvIndication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 22,
    rx: 11,
    fill: "#F0F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1424 15V6.27273H12.614V7.40625H8.45916V10.0653H12.3285V11.1946H8.45916V13.8665H12.6651V15H7.1424ZM15.1357 6.27273L17.5646 13.3807H17.6626L20.0916 6.27273H21.5149L18.3743 15H16.853L13.7124 6.27273H15.1357Z",
    fill: "#026AA2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvIndication);
export default __webpack_public_path__ + "static/media/ev-indication.c96faef8366233b5492035fee86344a2.svg";
export { ForwardRef as ReactComponent };